import Vue from 'vue'
import router from '@/router'

// /**
//  * 清除登录信息
//  */
// export function clearLoginInfo() {
//     Vue.cookie.delete('LPSWUTGT')
// }

// export  function setCapture(ttt){
//   var sRoot = process.env.NODE_ENV !== 'production' ?  'https://uss-test.lenovomm.cn' : location.protocol + '//' + location.host + '/';
//   var host = location.host;
//   if (host.indexOf('idinner1') != -1)  {
//     sRoot = 'https://uss-test.lenovomm.cn';
//   }
//   var sTmp = sRoot+'/capt/1.2/getimage?source=uss.test&t=' + ttt;
//   return sTmp
// }


export  function setCapture(ttt){
  var sRoot = process.env.NODE_ENV !== 'production' ?  'https://uss-test.lenovomm.cn' : location.protocol + '//' + location.host + '/';
  var host = location.host;
  if (host.indexOf('idinner1') != -1)  {
    sRoot = 'https://uss-test.lenovomm.cn';
  }
  var sTmp = sRoot+'/capt/1.2/getimage?source=uss.test&t=' + ttt;
  return sTmp
}
// 获取url参数
export function getRequest(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}




// WEBPACK FOOTER //
// ./src/utils/index.js